import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';

export default function Lister({
  sectionTitle,
  sectionDescription,
  description
}) {
  return (
    <div className="cs_shape_wrap">
      <div className="cs_shape_1" />
      <div className="container">
        <SectionHeading title={sectionTitle} center />
        <Spacing md="20" lg="20" sm="20" />
        <h3 className="cs_section_subtitle text-uppercase text-center cs_accent_color cs_semibold m-0 cs_accent_color cs_fs_32">
          {sectionDescription}
        </h3>
        <Spacing md="50" lg="30" />
        {description?.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <Spacing md="40" lg="60" sm="30" />}
            <p className="m-0 text-justify">{item}</p>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
